import Footer from 'layout/footer';
import Header from 'layout/header';
import { Fragment } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import React, { useEffect, useMemo, useState } from "react";

const PrivacyPolicyEng = () => {

    return (
        <Fragment>
            <Card.Header as="h5">Privacy Policy</Card.Header>
            <Card.Body className='p-4'>
                <div>
                     <p><b>Effective Date: [30 April 2025]</b></p>
                    <p>Welcome to  <strong>My Digital India App </strong> (“we”, “our”, or “us”)! This Privacy Policy explains how we collect, use, and protect your information when you use our platform to create websites using pre-designed templates—no coding required.<br />
                     <br />   By using the My Digital India App, you agree to the practices described in this policy. If you have any questions, feel free to contact us at [Email].</p>

                    <p><strong>1. Information We Collect</strong><br />
                        We collect different types of information depending on how you use our platform:</p>

                    <p><strong>a. Information You Provide</strong></p>
                    <ul style={{marginLeft: '1rem' }}>
                        <li> • <strong>Account details:</strong> Name, email address, phone number, and password when you sign up.</li>
                        <li> • <strong>Website content:</strong> Text, images, and data you upload or publish on your site.</li>
                        <li> • <strong>Billing details:</strong> If you subscribe to paid services, we may collect payment and billing info via third-party processors.</li>
                    </ul>
                    <br />
                    <p><strong>b. Information We Automatically Collect</strong></p>
                    <ul style={{marginLeft: '1rem' }}>
                        <li> • <strong>Log data:</strong> IP address, browser type, pages visited, and actions taken.</li>
                        <li> • <strong>Device info:</strong> Device type, operating system, screen size, etc.</li>
                        <li> • <strong>Cookies and tracking:</strong> We use cookies to understand how you use our platform and to personalize your experience.</li>
                    </ul>
                    <br />
                    <p><strong>2. How We Use Your Information</strong>
                     <br /> <br />  <b> We use the collected information to: </b></p>
                    <ul style={{marginLeft: '1rem' }}>
                        <li> • Create and manage your account.</li>
                        <li> • Provide and improve our website-building services.</li>
                        <li> • Process payments (via secure third-party providers).</li>
                        <li> • Send you important service updates and optional promotional messages.</li>
                        <li> • Prevent fraud and ensure platform security.</li>
                        <li> • Comply with legal requirements.</li>
                    </ul>
                    <br />
                    <p><strong>3. Sharing Your Information</strong><br />
                        We do not sell your personal data. We may share your information only with:</p>
                    <ul style={{marginLeft: '1rem' }}>
                        <li> • <strong>Service providers:</strong> Such as hosting, analytics, customer support, and payment gateways.</li>
                        <li> • <strong>Legal authorities:</strong> If required by law or to protect rights and safety.</li>
                        <li> • <strong>Other users:</strong> Only if you publish content on a website that is publicly accessible.</li>
                    </ul>
<br />
                    <p><strong>4. International Data Transfers</strong><br />
                        Although we are based in India, some of our service providers may be located outside India. In such cases, we take reasonable steps to ensure your data is transferred securely and treated in accordance with this policy.</p>

                    <p><strong>5. Ads and Analytics</strong><br />
                        We may use third-party services like Google Analytics or advertising networks. These third parties may collect data using cookies and similar tools to track your activity on our platform and others. This helps us improve our services and show relevant content or ads.<br />
                        We do not control how these third parties handle your data—please check their privacy policies.</p>

                    <p><strong>6. Using Third-Party Tools on Your Website</strong><br />
                        When you add third-party plugins, forms, embeds, or payment processors to your My Digital India App site, those third parties may collect data about your visitors. Their use of data is governed by their own privacy policies, not ours.<br />
                        As a site owner, you are responsible for informing your visitors how their data is used.</p>

                    <p><strong>7. Visitors to User Websites</strong><br />
                        If you are a visitor to a website created using the My Digital India App, we may process your data (such as IP address or browser info) on behalf of the site owner. That data is controlled by the site owner and not covered by this policy.<br />
                        If you have concerns, please contact the website owner directly.</p>

                    <p><strong>8. Your Rights and Choices</strong><br />
                        Depending on applicable laws (such as India’s upcoming Digital Personal Data Protection Act, or GDPR if you are an EU user), you may have the right to:</p>
                    <ul style={{marginLeft: '1rem' }}>
                        <li> • Access or correct your personal data.</li>
                        <li> • Delete your account or request data deletion.</li>
                        <li> • Object to certain uses of your data.</li>
                        <li> • Withdraw consent for marketing emails (unsubscribe anytime).</li>
                    </ul> <br />
                    <p>To make a request, email us at [Email].</p>

                    <p><strong>9. Data Security</strong><br />
                        We use strong security measures (like encryption, secure servers, and access controls) to protect your data. However, no system is 100% secure, so we encourage you to use strong passwords and keep your login info private.</p>

                    <p><strong>10. Retention of Data</strong><br />
                        We keep your data only as long as needed for the purposes listed above or as required by law. When you delete your account, we delete or anonymize your data unless retention is legally necessary.</p>

                    <p><strong>11. Changes to This Policy</strong><br />
                        We may update this Privacy Policy occasionally. When we do, we’ll post a notice on our site or email you. We encourage visitors to frequently check this page for any changes to our Privacy Policy. Continuing to use our services means you agree to the updated policy.</p>

                    <p><strong>12. Contact Us</strong><br />
                        Have questions or concerns? Reach out at:
                        <br /> <br />
                        <strong>My Digital India App</strong><br />
                        Email: info@mydigitalindia.app  <br />
                        Address: 705, Shekhar Central, Palasia Square, Indore (M.P.), India, 452001
                    </p>
                </div>

            </Card.Body>

        </Fragment>
    );
};

export default PrivacyPolicyEng;
